<!-- common-header.component.html -->
<ion-header [translucent]="translucent" [class.header-custom]="customClass">
  <ion-toolbar [class.toolbar-custom]="customClass">

    <!-- Left Side: Menu Button -->
    <ion-buttons slot="start">
      <ion-button *ngIf="showMenuButton" (click)="onMenuClick()">
        <ion-icon slot="start" src="assets/icons/menu.svg"></ion-icon>
        <!-- <ion-icon slot="start" name="menu-outline">
        </ion-icon> -->
      </ion-button>

      <!-- Back button (alternative to menu) -->
      <ion-button *ngIf="showBackButton" (click)="onMenuClick()">
        <ion-icon slot="start" name="arrow-back-outline" color="#404245">
        </ion-icon>
      </ion-button>
    </ion-buttons>

    <!-- Center: Logo/Title -->
    <div>
      <!-- Logo with optional link -->
      @if (showLogo) {
        <div class="logo-container">
          <img src="assets/images/logo_header.png" alt="Logo" class="logo-image">
        </div>
      }
      
    </div>
  </ion-toolbar>
</ion-header>
